interface addressDetailsType{
  apartment?:string,
  street_address:string,
  city:string,
  postcode:string
}

let map: google.maps.Map;
let markers: google.maps.Marker[] = [];
export interface GoogleAddressComponent{
  long_name:string,
  short_name:string,
  types: string[]
}
const useGoogleMapPlacesApiInit = (updateAddress?:(address:string)=>void)=> {

  const infoWindow = new google.maps.InfoWindow();
  
  const setAutocompleteInput = (inputID:string, callbackFunction:(addressComponent:GoogleAddressComponent[])=>void,) =>{
    const input = document.getElementById(inputID) as HTMLInputElement;
    const autocomplete = new google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: ["gb","uk"] },
    });
    autocomplete.addListener("place_changed", () => {
      infoWindow.close();
      console.log(autocomplete,autocomplete.getFields(),autocomplete.getBounds(),autocomplete.getPlace());
      const place: any = autocomplete.getPlace();
      if (!place.geometry || !place.geometry.location) {
        window.alert("No details available for input: '" + place.name + "'");
        return;
      }
      callbackFunction(place?.address_components)

    });
  }
  const initMap = async (defaultPin:addressDetailsType, setOriginalLocation:(location:object)=>void,locationNotFoundCallback:()=>void)=>{
    markers = [];
    const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
    map = new Map(
      document.getElementById("map") as HTMLElement,
      {
        center: { lat: 51.483045773305115, lng:-3.169688484657485 },
        zoom: 13,
        mapTypeId: "roadmap",
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: true,
        fullscreenControl: false
      }
    );
          
    changeMapLocation(`${defaultPin.postcode}, ${defaultPin.street_address}, ${defaultPin.city}`, setOriginalLocation, locationNotFoundCallback)
  }



    const changeMapLocation = (address:string, setOriginalLocation:(location:object)=>void, locationNotFoundCallback:()=>void) =>{
      const request = {
        query: address,
        fields: ["geometry"],
      };
      const service = new google.maps.places.PlacesService(map);
      service.findPlaceFromQuery(
        request,
        (
          results: google.maps.places.PlaceResult[] | null,
          status: google.maps.places.PlacesServiceStatus
        ) => {
           if (status === google.maps.places.PlacesServiceStatus.OK && results) {
            for (let i = 0; i < results.length; i++) {
              createMarker(results[i]);
            }
    
            map.setCenter(results[0].geometry!.location!);
            const pos = {
              lat:results?.[0]?.geometry!.location?.lat(),
              lng:results?.[0]?.geometry!.location?.lng()
            }
            setOriginalLocation(pos)
            
          }else{
            locationNotFoundCallback();
          }
        });
}
    

function createMarker(place: google.maps.places.PlaceResult) {
  if (!place.geometry || !place.geometry.location) return;

  const marker = new google.maps.Marker({
    map,
    position: place.geometry.location,
    draggable:true
  });
  markers.push(marker);
  map.setCenter(place.geometry.location);
  map.setZoom(16);

  google.maps.event.addListener(marker, "click", () => {
    infoWindow.setContent(place.name || "");
    infoWindow.open(map);
  });
}

const getMarkerLocation = ()=>{
  const markerLocation = markers[0]?.getPosition();
  return {
    lat: markerLocation?.lat(),
    lng: markerLocation?.lng(),
  };
}





  return {
    // changeMapLocation: changeMapLocation,
    setAutocompleteInput:setAutocompleteInput,
    initMap:initMap,
    getMarkerLocation:  getMarkerLocation
  }

  }

  
export default useGoogleMapPlacesApiInit;